// Replaces card-img-top thumbnails that error out (mainly on staging) with a placeholder image
// Useful for testing production data on staging where the image data is present but from the wrong bucket
document.addEventListener(
  "error",
  function (e) {
    // Prevent infinite loops in case the placeholder image fails to load by checking dataset.errorHandled
    if (
      e.target.tagName.toLowerCase() == "img" &&
      e.target.classList.contains("card-img-top") &&
      !e.target.dataset.errorHandled
    ) {
      e.target.dataset.errorHandled = true
      e.target.src =
        "https://assets.superhivestaging.com/site_assets/image-placeholder.png"
    }
  },
  true
)
